const state = {
  products: [],
  selectedPlan: null,
  subscriptions: [],
  loading: false,
  error: null
};

const mutations = {
  SET_PRODUCTS(state, products) {
    state.products = products;
  },
  SET_SELECTED_PLAN(state, plan) {
    state.selectedPlan = plan;
  },
  SET_SUBSCRIPTIONS(state, subscriptions) {
    state.subscriptions = subscriptions;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
  CLEAR_ERROR(state) {
    state.error = null;
  }
};

const actions = {
  setProducts({ commit }, products) {
    commit('SET_PRODUCTS', products);
  },
  
  selectPlan({ commit }, plan) {
    commit('SET_SELECTED_PLAN', plan);
    console.log('[LemonSqueezy Store] Plan selected:', plan);
  },
  
  setSubscriptions({ commit }, subscriptions) {
    commit('SET_SUBSCRIPTIONS', subscriptions);
  },
  
  setLoading({ commit }, loading) {
    commit('SET_LOADING', loading);
  },
  
  setError({ commit }, error) {
    commit('SET_ERROR', error);
  },
  
  clearError({ commit }) {
    commit('CLEAR_ERROR');
  },
  
  // Action to fetch and store products
  async fetchAndStoreProducts({ commit, dispatch }) {
    commit('SET_LOADING', true);
    commit('CLEAR_ERROR');
    
    try {
      // This will be called from components using the useLemonSqueezy composable
      // The actual API call happens in the composable, then we store the result here
      console.log('[LemonSqueezy Store] Ready to fetch products');
    } catch (error) {
      console.error('[LemonSqueezy Store] Error in fetchAndStoreProducts:', error);
      commit('SET_ERROR', error.message);
      dispatch('showAlert', {
        message: 'Failed to load subscription plans. Please try again.',
        type: 'error'
      }, { root: true });
    } finally {
      commit('SET_LOADING', false);
    }
  }
};

const getters = {
  products: state => state.products,
  selectedPlan: state => state.selectedPlan,
  subscriptions: state => state.subscriptions,
  loading: state => state.loading,
  error: state => state.error,
  hasProducts: state => state.products && state.products.length > 0,
  
  // Get products with their variants organized
  productsWithVariants: state => {
    return state.products.map(product => ({
      ...product,
      variants: product.variants || []
    }));
  },
  
  // Find a specific plan by variant ID
  getPlanById: state => id => {
    for (const product of state.products) {
      if (product.variants) {
        const variant = product.variants.find(v => v.id === id);
        if (variant) {
          return {
            ...variant,
            product: {
              id: product.id,
              name: product.attributes?.name,
              description: product.attributes?.description
            }
          };
        }
      }
    }
    return null;
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
